import { render, staticRenderFns } from "./dialog_onlineGoods.vue?vue&type=template&id=01a1015a&scoped=true&"
import script from "./dialog_onlineGoods.vue?vue&type=script&lang=js&"
export * from "./dialog_onlineGoods.vue?vue&type=script&lang=js&"
import style0 from "./dialog_onlineGoods.vue?vue&type=style&index=0&id=01a1015a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1015a",
  null
  
)

export default component.exports